import React from 'react';
import { withRouter, Route } from 'react-router-dom';
import NoMatchPage from '../App/404';
import UsersList from './UsersList';

const UserManagementPage = props => {
  const { match } = props;
  return (
    <>
      <Route exact path={match.path} component={UsersList} />
      <Route path={match.path + '/*'} component={NoMatchPage} />
    </>
  );
};

export default withRouter(UserManagementPage);
